const TAG_STYLE = {
  fontSize: 12,
  lineHeight: "1.4",
  background: "#ccc",
  display: "inline-block",
  color: "#000",
  position: "relative",
  padding: "3px 6px",
  marginRight: 7,
  textDecoration: "none"
};

let TagPreview = ({ label, color }) => {
  return (
    <div style={Object.assign({}, TAG_STYLE, { backgroundColor: color })}>
      {label}
    </div>
  );
};

export default TagPreview;



// WEBPACK FOOTER //
// ./src/app/components/partials/tag-preview.jsx